import { BaseEntity } from '../core/entities/base.entity';

export class SubjectEntity extends BaseEntity {
  name!: string;
  region?: string;
  treeId?: string;
  root?: boolean;
  active!: boolean;
  nodeType?: string;
  children?: string[];
  version?: number;
  updated?: Date;
  changedBy?: string;
  _t?: string;
  ageGroup?: string;
  suggestion?: string[];
}
